import { createSlice } from "@reduxjs/toolkit";
import {
  AllBannersThunk,
  GetSingleBannersThunk,
  AddBannersThunk,
  UpdateBannersThunk,
  DeleteBannersThunk,
} from "./thunk";

const initialState = {
  banners: [],
  singleBanner: null,
  loading: false,
  error: null,
  successMessage: null,
};

const bannersSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {
    clearBannerState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------- ALL BANNERS --------------------
      .addCase(AllBannersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllBannersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.banners = action.payload?.data || [];
      })
      .addCase(AllBannersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE BANNER --------------------
      .addCase(GetSingleBannersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleBannersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleBanner = action.payload?.data || null;
      })
      .addCase(GetSingleBannersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- ADD BANNER --------------------
      .addCase(AddBannersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddBannersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = "Banner added successfully!";
      })
      .addCase(AddBannersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- UPDATE BANNER --------------------
      .addCase(UpdateBannersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateBannersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = "Banner updated successfully!";
      })
      .addCase(UpdateBannersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- DELETE BANNER --------------------
      .addCase(DeleteBannersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteBannersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.banners = state.banners.filter(
          (b) => b.uuid !== action.payload.uuid
        );
        state.successMessage = "Banner deleted successfully!";
      })
      .addCase(DeleteBannersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBannerState } = bannersSlice.actions;
export default bannersSlice.reducer;
